import { OptionTypeBase } from 'react-select/src/types';

export const groupByOptions: readonly OptionTypeBase[] = [
  {
    id: 'none',
    name: 'None',
  },
  {
    id: 'custom_id',
    name: 'Custom ID',
  },
  {
    id: 'custom_id,station_id',
    name: 'Custom ID and station',
  },
];
